module.exports = require("@workbench-stack/platform/lib/package");